import React, { useCallback } from 'react';

import Tooltip, { TooltipStyle } from '../tooltip';

import { CURRENT_LOCALE, Direction } from 'src/constants';
import type { TooltipTriggerProps } from './tooltip-trigger.props';

function TooltipTrigger({ children, isHideOnScroll = true, text }: TooltipTriggerProps) {
  const startDirection = CURRENT_LOCALE === 'he' ? Direction.RIGHT : Direction.LEFT;
  const tooltipRef = React.useRef<HTMLDivElement | null>(null);
  const [showTooltip, setShowTooltip] = React.useState(false);
  const [tooltipStyle, setTooltipStyle] = React.useState<TooltipStyle>({
    [startDirection]: '',
    top: '',
  });

  const handleTooltipEnter = () => {
    const {
      [startDirection]: startDirectionValue,
      width,
      top,
    } = tooltipRef.current!.getBoundingClientRect();
    setShowTooltip(true);
    const tooltipHorizontalPosition =
      (startDirection === Direction.RIGHT
        ? window.innerWidth - startDirectionValue
        : startDirectionValue) +
      width * 3 -
      6;
    setTooltipStyle({
      [startDirection]: `${tooltipHorizontalPosition}px`,
      top: `${top + 10}px`,
    });
  };

  const hideTooltip = useCallback(() => {
    setShowTooltip(false);
  }, []);

  React.useEffect(() => {
    if (isHideOnScroll) {
      if (showTooltip) {
        window.addEventListener('scroll', hideTooltip, true);
      } else {
        window.removeEventListener('scroll', hideTooltip, true);
      }
    }

    return () => {
      if (isHideOnScroll) {
        window.removeEventListener('scroll', hideTooltip, true);
      }
    };
  }, [hideTooltip, isHideOnScroll, showTooltip]);

  return (
    <div
      className="tooltip-trigger"
      onMouseEnter={handleTooltipEnter}
      onMouseLeave={hideTooltip}
      ref={tooltipRef}
    >
      {showTooltip && <Tooltip text={text} style={tooltipStyle} />}

      {children}
    </div>
  );
}

export default TooltipTrigger;
